import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../../redux/action_creators';
import { api_with_method } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import Button from '../../../util_components/button';
import CustomLoading from '../../../util_components/custom_loading';
import CustomSingleSelect from '../../../util_components/custom_single_select';

function AddCreditForMembership(props) {
  const customAmount = [
    { value: 50, label: '50' },
    { value: 100, label: '100' },
    { value: 'custom', label: 'Custom Amount' }
  ];
  const [amount, setAmount] = useState();
  const [customAmountValue, setCustomAmountValue] = useState('');
  const [reasonForAward, setReasonForAward] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);

  const dispatach = useDispatch();

  const handleReasonChange = (e) => {
    setReasonForAward(e.target.value);
    resetError();
  };
  const handleCustomAmountChange = (e) => {
    if (e.target && e.target.value) {
      setAmount(e.target.value);
      if (e.target.value !== 'custom') {
        setCustomAmountValue('');
      }
      resetError();
    }
  };
  const handleCustomAmountValueChange = (e) => {
    const { value } = e.target;
    if (value === '' || /^\d+$/.test(value)) {
      setCustomAmountValue(value);
      resetError();
    }
  };

  const resetError = () => {
    setShowError(false);
    setError('');
  };

  const getCreditAmount = () => {
    if (amount === 'custom') {
      return Number(customAmountValue);
    }
    return Number(amount);
  };

  const handleSubmit = async () => {
    if (typeof amount === 'undefined' || amount === '') {
      setShowError(true);
      setError('Please Select Amount');
    } else if (
      amount === 'custom' &&
      (customAmountValue === '' || Number(customAmountValue) <= 0)
    ) {
      setShowError(true);
      setError('Please enter a valid custom amount');
    } else if (reasonForAward.trim() === '') {
      setShowError(true);
      setError('Please enter the reason');
    } else {
      const payload = {
        student_uuid: props.studentUUID,
        credits: getCreditAmount(),
        reason: reasonForAward
      };

      const url = get_api_url('/v2/payments/cms/membership_credits', null, true);
      setLoading(true);
      try {
        await api_with_method('post', url, payload, true);
        closeCustomAmountChange();
        dispatach(actions.set_notification_variable(true, 'success', 'Credit Added'));
      } catch (error) {
        setLoading(false);
        setError(error?.response?.data?.reason);
        setShowError(true);
      }
    }
  };

  const closeCustomAmountChange = () => {
    setShowError(false);
    setError('');
    setAmount('');
    setCustomAmountValue('');
    setReasonForAward('');
    props.closeCreditForMembership();
  };

  return (
    <>
      {loading ? (
        <CustomLoading />
      ) : (
        <div>
          <hr className="-mx-6 mb-6 border-gray-200" />
          <div className="flex items-center justify-between rounded-lg bg-[#FDF2E9] px-4 py-3 mb-6">
            <div className="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5 text-mytPrimary"
              >
                <path d="M3 6.75A2.75 2.75 0 0 1 5.75 4h11.5a1 1 0 1 1 0 2H5.75a.75.75 0 0 0-.75.75V8h14.5A2.5 2.5 0 0 1 22 10.5v7A2.5 2.5 0 0 1 19.5 20h-14A2.5 2.5 0 0 1 3 17.5V6.75ZM18 15a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" />
              </svg>
              <span className="font-semibold text-mytBlue">Current Available Credits</span>
            </div>
            <span className="font-bold text-mytBlue">{props.membershipCredits ?? 0} Credits</span>
          </div>
          <div className="flex flex-col gap-4">
            <div>
              <CustomSingleSelect
                label="*Select Amount"
                options={customAmount}
                onChange={handleCustomAmountChange}
                value={amount}
                defaultOption="Choose credit amount"
                style={{ width: '100%', height: '40px', padding: '0 8px', borderRadius: '6px' }}
              />
              {amount === 'custom' ? (
                <input
                  type="text"
                  inputMode="numeric"
                  value={customAmountValue}
                  onChange={handleCustomAmountValueChange}
                  placeholder="Enter custom amount"
                  className="w-full mt-2 px-3 h-10 text-sm border border-borderColor rounded-md focus:outline-none focus:border-mytPrimary"
                />
              ) : null}
            </div>
            <div>
              <div className="custom-single-select-label">*Reason for Award:</div>
              <textarea
                value={reasonForAward}
                name="reasonForAward"
                onChange={handleReasonChange}
                placeholder="Explain why these credits are being awarded for renewal..."
                className="w-full min-h-[120px] mt-2 px-3 py-2 text-sm border border-borderColor rounded-md resize-y focus:outline-none focus:border-mytPrimary"
              />
            </div>
          </div>
          {showError ? (
            <div className="font-bold text-red-700 mt-4 text-center">{error}</div>
          ) : null}
          <hr className="-mx-6 mt-6 mb-4 border-gray-200" />
          <div className="flex justify-end items-center gap-3">
            <Button type="secondary" onClick={closeCustomAmountChange}>
              Cancel
            </Button>
            <Button onClick={handleSubmit}>Submit</Button>
          </div>
        </div>
      )}
    </>
  );
}

export default AddCreditForMembership;
